module.exports = __webpack_public_path__ + "img/pound.b9e0bafc.svg";